export default class imageBank {
    constructor() {
        return {
            restrict: 'E',
            controller: 'ImageBankCtrl',
            controllerAs: 'img',
            template: require('../../../../views/directives/image-bank/imagebank.html')
        }
    }
};
